<template>
	<PageCrumbHeaderLayout class="page-crumb-header-skeleton"
		:crumbs="crumbs"
		:disabled="true"
	>
		<template #title>
			<div class="page-crumb-header-skeleton-title">
				<Skeleton />
			</div>
		</template>
	</PageCrumbHeaderLayout>
</template>

<script>
import Skeleton from "primevue/skeleton";
import PageCrumbHeaderLayout from "./PageCrumbHeaderLayout.vue";
export default {
	name: "PageCrumbHeaderSkeleton",
	emits: [ "back", "crumb", ],
	components: {
		PageCrumbHeaderLayout,
		Skeleton,
	},
	props: {
		/** [ { text:String, route:String, isActive:Boolean, }, ... ] */
		crumbs: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped>
.page-crumb-header-skeleton-title {
	max-width: 50rem;
}
</style>
